import React from 'react';
import { ResponsiveDataList, type Column } from '@shared/ui/adaptive';
import type { CollectionItem } from '../types';

export interface CollectionItemsListProps {
  items: CollectionItem[];
  onItemClick?: (item: CollectionItem) => void;
}

// CollectionItemsList displays CMS entries using ResponsiveDataList without authoring raw table tags (M-I3).
export function CollectionItemsList({
  items,
  onItemClick,
}: CollectionItemsListProps): React.JSX.Element {
  const columns: Column<CollectionItem>[] = [
    {
      key: 'slug',
      header: 'Slug / Path',
      render: (item: CollectionItem) => <span className="font-mono text-xs">{item.item_slug}</span>,
      width: '30%',
    },
    {
      key: 'status',
      header: 'Status',
      render: (item: CollectionItem) => (
        <span
          className={`px-2 py-0.5 rounded-full text-xs font-semibold uppercase tracking-wider ${
            item.status === 'published'
              ? 'bg-accent/15 text-accent'
              : 'bg-muted text-muted-foreground'
          }`}
        >
          {item.status}
        </span>
      ),
      width: '20%',
    },
    {
      key: 'updated',
      header: 'Last Updated',
      render: (item: CollectionItem) => <span className="text-muted-foreground text-xs">{item.updated_at}</span>,
    },
  ];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-foreground">Collection Records</h2>
        <span className="text-xs text-muted-foreground">{items.length} total entries</span>
      </div>
      <ResponsiveDataList<CollectionItem>
        data={items}
        keyExtractor={(item: CollectionItem) => item.id}
        columns={columns}
        emptyMessage="No collection items found. Click 'Add Item' to create one."
        onItemClick={onItemClick}
      />
    </div>
  );
}
